import { memo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader, BzModalTitle } from "../../../components";

const arrMandateOptions = [
    { name: 'Axis Bank XX 3456', id: '7463784939' },
    { name: 'ICICI Bank XX 4567', id: '7463784938' },
    { name: 'SBI XX 4590', id: '7463784937' }
];

const defaultMandate = '7463784939';

const Mandate = ({ showMandateModal, setIsShowMandateModal }) => {

    return (
        <BzModal size='md' show={showMandateModal} onHide={setIsShowMandateModal} centered>
            <Container fluid className='p-0'>
                <BzModalHeader className='modaltabs-header d-block p-3'>
                    <Row className='g-0'>
                        <Col md={10} className='d-flex justify-content-start align-self-center'>
                            <BzModalTitle className='font-medium font-size4 color-text'>Select Mandate</BzModalTitle>
                        </Col>
                        <Col md={2} className='d-flex justify-content-end align-self-center'>
                            <div className='icon-16 icon-close icon-dark ms-3'></div>
                        </Col>
                    </Row>
                </BzModalHeader>

                <BzModalBody>
                    <Container fluid className='p-0 mt-4'>
                        {arrMandateOptions.map(mandate => {
                            return (
                                <div key={mandate.id} className='d-flex mb-4'>
                                    <input className='form-check-input me-2' type="radio" name="mandate" defaultChecked={mandate.id === defaultMandate} />
                                    <Row className='g-0 p-0'>
                                        <Col>
                                            <div className='font-medium font-size3 color-text'>{mandate.name}</div>
                                            <div className='d-flex justify-content-start align-items-center'>
                                                <div className='font-regular font-size4 color-subtext pe-1'>Mandate ID:</div>
                                                <div className='font-regular font-size3 color-text'>{mandate.id}</div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>);
                        })}
                        <Row className='g-0'>
                            <Col className='d-flex align-items-center mt-3'>
                                <div className='d-flex justify-content-start align-items-center' onClick={() => { setIsShowMandateModal(true); }}>
                                    <div className='icon-14 icon-add background-textual-link-withicon me-2'></div>
                                    <div className='font-medium font-size4 color-textual-link-withicon cursor-pointer'>Add New Mandate</div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalBody>

                <BzModalFooter>
                    <Row className='g-0 py-2 justify-content-end'>
                        <Col md={4} className='d-flex align-items-center'>
                            <BzButton className='btn btn-md btn-block btn-primary text-uppercase'>Choose and Continue</BzButton>
                        </Col>
                    </Row>
                </BzModalFooter>
            </Container>
        </BzModal>
    );
};
export default memo(Mandate);